var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "about-boat", class: { _open: _setup.isOpen } },
    [
      _c("div", { staticClass: "about-boat__header" }, [_vm._v("О теплоходе")]),
      _vm._v(" "),
      _c("div", { staticClass: "about-boat__content" }, [
        _c("div", { staticClass: "about-boat__head" }, [
          _c("div", { staticClass: "about-boat__title" }, [
            _vm._v(_vm._s(_setup.fullName)),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "about-boat__company" }, [
            _vm._v(_vm._s(_setup.shipCompany)),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "about-boat__slider" },
          [
            _c(_setup.MySlider, {
              staticClass: "cruise-info__slider",
              attrs: {
                slideRatio: 1 / 2,
                slides: _setup.photos,
                srcKey: "src_next",
                idKey: "id",
                titleKey: "title",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "about-boat__info" },
          [
            _c(
              _setup.InsertHtml,
              _vm._b({}, "InsertHtml", _setup.descriptionBig, false)
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "about-boat__link",
                attrs: { to: _setup.ship_link, target: "_blank" },
              },
              [_vm._v("\n          Полное описание теплохода\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "about-boat__action" }, [
          _c("div", {
            staticClass: "about-boat__mask-action",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _setup.toggle.apply(null, arguments)
              },
            },
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "about-boat__btn-action",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _setup.toggle.apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_setup.isOpen ? "Свернуть" : "Развернуть") +
                  "\n      "
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }